<template>
    <!-- <v-container :loading="loading">
         <v-page-title title="Автопродвижение" to="admin-promotion" />

         <v-cover>
             <v-form @submit="send">
                 <v-fields>
                     <div class="row">
                         <div class="col-md-12">
                             <v-input name="url" title="URL" validate="required|url" v-model="request.url" />
                         </div>
                     </div>
                 </v-fields>

                 <div class="center">
                     <v-button style="margin-top: 24px;">
                         {{ id ? "Сохранить" : "Создать" }}
                     </v-button>
                 </div>
             </v-form>
         </v-cover>
     </v-container>-->
    <div>
        <v-page-title title="Автопродвижение" to="admin-promotion" />
        <v-form @submit="send">
            <v-fields>
                <div class="row">
                    <div class="col-md-12">
                        <v-input name="url" title="URL" validate="required|url" v-model="request.url" />
                    </div>
                </div>
            </v-fields>

            <div class="center">
                <v-button style="margin-top: 24px;">
                    {{ id ? "Сохранить" : "Создать" }}
                </v-button>
            </div>
        </v-form>
    </div>
</template>

<script>
import { api } from "../../services/api";

export default {
    name: "PromotionAutoForm",
    $_veeValidate: {
        validator: "new"
    },
    mounted() {
        if (this.id) {
            this.load();
        }
    },
    data() {
        return {
            loading: false,
            request: {
                url: ""
            }
        };
    },
    computed: {
        id() {
            return this.$route.params.id;
        }
    },
    methods: {
        load() {
            if (this.id) {
                this.$set(this, "loading", true);
                api.promotion.auto
                    .get(this.id)
                    .then(({ data }) => {
                        this.setModel(data);
                    })
                    .finally(() => {
                        this.$set(this, "loading", false);
                    });
            }
        },
        send() {
            if (!this.loading) {
                this.$validator.validateAll("form").then(data => {
                    if (data) {
                        this.$set(this, "loading", true);
                        if (this.id) {
                            api.promotion.auto
                                .update(this.id, this.request)
                                .then(({ data }) => {
                                    this.notify("Изменения сохранены", null, "success");
                                    this.setModel(data);
                                })
                                .finally(() => {
                                    this.$set(this, "loading", false);
                                });
                        } else {
                            api.promotion.auto
                                .create(this.request)
                                .then(({ data }) => {
                                    this.notify("Успешно создано", null, "success");
                                    this.$router.replace({
                                        name: "admin-promotion-auto-edit",
                                        params: { id: data.id }
                                    });
                                })
                                .finally(() => {
                                    this.$set(this, "loading", false);
                                });
                        }
                    }
                });
            }
        },
        setModel(data) {
            this.$set(this.request, "url", data.url);
        }
    }
};
</script>

<style scoped></style>
